import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=e5bdd3cc&scoped=true"
import script from "./StoreDetail.vue?vue&type=script&lang=js"
export * from "./StoreDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bdd3cc",
  null
  
)

export default component.exports